import { DIFFICULTY, GAME } from '../config.js';

export function getDifficultySettings(difficulty = 'normal') {
    return DIFFICULTY[difficulty] || DIFFICULTY.normal;
}

export function getProgressMultiplier(elapsedSeconds, durationSeconds) {
    if (!durationSeconds || durationSeconds <= 0) return 1;
    const progress = Math.max(0, Math.min(1, elapsedSeconds / durationSeconds));
    return 1 + progress * 0.35;
}

/**
 * Ease-in ramp: stays slow early, then accelerates toward full pace.
 * @returns {number} Multiplier in [minMultiplier, 1]
 */
export function getPaceRampMultiplier(elapsedSeconds, rampSeconds, minMultiplier) {
    if (!rampSeconds || rampSeconds <= 0) return 1;
    const linear = Math.max(0, Math.min(1, elapsedSeconds / rampSeconds));
    const eased = linear * linear;
    return minMultiplier + (1 - minMultiplier) * eased;
}

/** Spawn interval divisor — higher = more spawns. */
export function getSpawnRampMultiplier(
    elapsedSeconds,
    rampSeconds = GAME.SPAWN_RAMP_SECONDS,
    minMultiplier = GAME.SPAWN_RAMP_MIN_MULTIPLIER,
) {
    return getPaceRampMultiplier(elapsedSeconds, rampSeconds, minMultiplier);
}

/** Drift speed scale for floating items. */
export function getMotionSpeedMultiplier(
    elapsedSeconds,
    rampSeconds = GAME.MOTION_RAMP_SECONDS,
    minMultiplier = GAME.MOTION_RAMP_MIN_MULTIPLIER,
) {
    return getPaceRampMultiplier(elapsedSeconds, rampSeconds, minMultiplier);
}

export function getSpawnInterval(
    settings,
    elapsedSeconds = 0,
    durationSeconds = 90,
    random = Math.random,
) {
    const [min, max] = settings.spawnIntervalMs;
    const multiplier =
        getProgressMultiplier(elapsedSeconds, durationSeconds) *
        getSpawnRampMultiplier(elapsedSeconds);
    const base = min + random() * (max - min);
    return Math.max(420, Math.round(base / multiplier));
}
